import { View } from "extensions/marionette";
import { _ } from "extensions/underscore";

import { Dropdown } from "common/components/dropdown/dropdown";

import paginationTemplate from "./pager.jst";

import "./paginator.scss";

export const PagerView = View.extend({
    className: "pz-pagination row clearfix",
    template: paginationTemplate,
    events: {
        "click .pagination > li": function(e) {
            e.preventDefault();
            this.gotoPage(e.currentTarget.getAttribute("value"));
        },
        "click @ui.goButton": function(e) {
            e.preventDefault();
            this.goButton();
        },
        "focus @ui.goToInput": "selectInputContent",
        "keypress @ui.goToInput": "filterTypedContent"
    },
    ui: {
        goToInput: "input.gotoPage",
        goButton: ".go-button a"
    },
    
    regions: {
        limitPicker: ".limit-picker"
    },
    
    modelEvents: {
        change: "render"
    },
    
    goButton() {
        return this.gotoPage(this.ui.goToInput.val());
    },
    
    addLimitPicker() {
        const data = this.getPagerData();
        
        if (data.range.length) {
            this.showChildView("limitPicker", new Dropdown({
                keepElOnDestroy: true,
                model: this.model,
                collection: [10, 25, 50, 100].map((value) => ({
                    name: value.toString(),
                    value
                })),
                property: "limit",
                direction: {
                    vertical: "up",
                    horizontal: "right"
                }
            }));
        }
    },
    
    onRender() {
        this.addLimitPicker();
    },
    
    /**
     * Go to requested page
     * @param {Number} page
     */
    gotoPage(page) {
        const pageNormalized = Number.parseInt(page, 10);
        
        if (!_.isNumber(pageNormalized)) {
            throw new TypeError("Wrong page format");
        }
        
        // If requested page is available for a given dataset then go there. Otherwise revert back to previous value
        if (page > 0 && page <= Math.ceil(this.model.get("total") / this.model.get("limit"))) {
            this.model.set("page", pageNormalized);
        } else {
            this.ui.goToInput.val(this.model.get("page"));
        }
    },
    
    /**
     * Only allow number in the input
     * @param {object} e keypress event
     */
    filterTypedContent(e) {
        // If it's enter then execute goto event
        if (e.keyCode === 13) {
            return this.goButton();
        }
        
        // Check if the keycode in the range and if it's not prevent the event
        if (!(e.which >= 48 && e.which <= 58)) {
            e.preventDefault();
        }
    },
    
    /**
     * Select entire content of the goto input for easy re-entry
     */
    selectInputContent() {
        this.ui.goToInput[0].select();
    },
    
    changeLimit(limit) {
        if (!Number.isFinite(limit)) {
            throw new TypeError("Wrong limit format");
        }
        this.model.set("limit", limit);
    },
    
    getPagerData() {
        const data = this.model.toJSON();
        
        let numPages = 1;
    
        // Divide by limit and determine the number of pages that exist.
        if (data.limit) {
            numPages = Math.ceil(data.total / data.limit);
        }
    
        // Check if rangeLength is greater than the amount of pages.
        let low = 1;
        let high = null;
        
        // If page number is big then change rangeLength to accommodate big numbers
        const rangeLength = 11 - data.page.toString().length;
        
        if (rangeLength > numPages) {
            high = numPages + 1;
        } else {
            high = rangeLength;
            const rangeHalf = Math.ceil(rangeLength / 2);
            if ((data.page > rangeHalf) && (data.page < ((numPages - rangeHalf) + 1))) {
                const diff = data.page - rangeHalf;
                low += diff;
                high += diff;
            } else if (data.page >= ((numPages - rangeHalf) + 1)) {
                high = numPages + 1;
                low = high - rangeLength;
            }
        }
    
        const range = _.range(low, high);
    
        return {
            pages: numPages,
            pageidx: data.page,
            range,
            limit: data.limit
        };
    },
    
    serializeData() {
        return this.getPagerData();
    }
});
